<template>
  <div class="user-chat-box bg-light card text-sm">
    <div
      class="card-header bg-dark text-center text-white pa-0"
      @click="toggleCollapse"
    >
      <div class="d-flex align-items-center pa-2">
        <span
          v-if="unread > 0"
          class="badge badge-danger"
        >{{ unread }}</span>
        <p class="flex-grow-1 mb-0">
          💬 ติดต่อเอเจนท์
        </p>
        <i
          id="caret"
          :class="{
            fa: true,
            'fa-caret-down': true,
            'd-flex': true,
            'mr-2': true,
            more: !isChatOpen,
          }"
        />
      </div>
      <marquee
        v-if="hotnews.length > 0"
        id="marquee"
        scrollamount="4"
        class="bg-primary text-white"
      >
        <div
          v-for="text in hotnews"
          class="d-inline-block mx-5"
          v-html="text"
        />
      </marquee>
    </div>
    <div
      id="messageWrapper"
      :class="{ collapse: !isChatOpen }"
    >
      <div
        id="messageContainer"
        class="card-body"
      >
        <img
          v-if="cleanLineUrl.startsWith('https://lin.ee/')"
          class="p-2"
          :src="qrCodeUrl"
          alt="LINE QR"
        >
        <!-- Link -->
        <p
          v-if="cleanLineUrl"
          class="p-2 text-left"
        >
          <a
            :href="cleanLineUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ cleanLineUrl }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'UserMessagesList',
  components: {
  },
  props: {
    participant: { type: Object, default: null },
  },
  data() {
    return {
      lastMessage: null,
      unread: 0,
      is_more: true,
      is_loading: false,
      typed_message: '',
    };
  },
  computed: {
    ...mapState({
      hotnews: (state) => state.user.hotnews,
      isChatOpen: (state) => state.app.isChatOpen,
    }),

    // 👉 เอา URL ออกจาก HTML (<p>...</p>)
    cleanLineUrl() {
      if (!this.participant || !this.participant.detail) return '';

      const div = document.createElement('div');
      div.innerHTML = this.participant.detail;

      let url = div.textContent || div.innerText || '';
      url = url.trim();

      // กันกรณีไม่มี http
      if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
        url = `https://${url}`;
      }

      return url;
    },

    // 👉 สร้าง QR
    qrCodeUrl() {
      if (!this.cleanLineUrl) return '';

      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.cleanLineUrl)}`;
    },
  },
  watch: {

  },
  created() {},
  mounted() {
    if (this.$store.state.app.isChatOpen) {
      document.getElementById('messageWrapper').classList.remove('collapse');
      document.getElementById('caret').classList.remove('more');
    } else {
      document.getElementById('messageWrapper').classList.add('collapse');
      document.getElementById('caret').classList.add('more');
    }
  },
  methods: {
    toggleCollapse(event) {
      if (
        document.getElementById('messageWrapper').classList.contains('collapse')
      ) {
        this.unread = 0;
        const container = document.getElementById('messageContainer');
        setTimeout(() => {
          container.scrollTop = container.scrollHeight;
        }, 600);
        this.$store.commit('app/openChat');
      } else {
        this.$store.commit('app/closeChat');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.user-chat-box {
  bottom: -1px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px;
  display: block;
  position: fixed;
  width: 300px;
  margin: 0 auto;
  left: 50%;
  transform: translateX(-50%);

  @media screen and (min-width: 768px) {
    left: unset;
    transform: unset;
    right: 0;
    margin-right: 20px;
  }

  .card-header {
    cursor: pointer;
  }

  .card-body {
    height: 400px;
    max-height: 40vh;
    overflow-y: scroll;
  }
}
#caret {
  transition: all 0.4s;
  &.more {
    transform: rotate(180deg);
  }
}
#messageContainer {
  transition: all 0.3;
  scroll-behavior: smooth;
}
#messageWrapper {
  position: relative;
}
#messageLoading {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(255, 255, 255, 0.5);
}
#marquee {
  margin-bottom: -5px;
}
</style>
